"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCookieValue = getCookieValue;
exports.getLocalVisitorId = getLocalVisitorId;
exports.deleteRecentlyViewedProducts = exports.fetchRecentlyViewedProducts = exports.triggerAnalyticsEvents = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.match");

var _axios = _interopRequireDefault(require("axios"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _constants = require("../constants");

var _uigOmniture = _interopRequireDefault(require("@sfly/uig-omniture"));

function getCookieValue(cookieName) {
  if (typeof window === 'undefined') {
    return null;
  }

  var match = document.cookie.match(new RegExp("(^| )".concat(cookieName, "=([^;]+)")));

  if (match) {
    return match[2];
  }

  return null;
}

function getLocalVisitorId() {
  var env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();

  if (env && env !== 'production') {
    env = "_".concat(env);
  } else {
    env = '';
  }

  var visitorId = getCookieValue("visitor".concat(env)) || '';
  return visitorId.replace(/['"]+/g, '');
}

var triggerAnalyticsEvents = function triggerAnalyticsEvents(eventTrackingConfig) {
  var isDTLEnabled = _uigOmniture.default.isDTLEnabled();

  if (isDTLEnabled) {
    _uigOmniture.default.putOmniture(eventTrackingConfig);
  } else if (isDTLEnabled === undefined) {
    var appcodeHostname = (0, _uigCurrentEnvironmentUtil.getBaseHostname)();

    _uigOmniture.default.setupOmnitureTracking("https://www.".concat(appcodeHostname), function (isDtlEnabled) {
      if (isDtlEnabled === true) {
        _uigOmniture.default.putOmniture(eventTrackingConfig);
      }
    });
  }
};

exports.triggerAnalyticsEvents = triggerAnalyticsEvents;

var getRequestConfigByUserType = function getRequestConfigByUserType(config) {
  var jwtToken = config.jwtToken,
      userId = config.userId,
      _config$brandType = config.brandType,
      brandType = _config$brandType === void 0 ? 'SFLY' : _config$brandType;
  var currentEnv = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
  var hostname = (0, _uigCurrentEnvironmentUtil.getHostname)('api2');
  var requestUrl = "https://".concat(hostname, "/usersvc/api/v1/brand/").concat(brandType);
  var requestOptions = {
    headers: {
      'SFLY-apikey': _constants.CLOUD_API_KEY[currentEnv]
    }
  };

  if (jwtToken && userId) {
    requestUrl = "".concat(requestUrl, "/user/").concat(userId, "/recently-viewed");
    requestOptions.headers.Authorization = "Bearer ".concat(jwtToken);
  } else {
    var visitorId = getLocalVisitorId();
    requestUrl = "".concat(requestUrl, "/visitor/").concat(visitorId, "/recently-viewed");
  }

  return {
    requestUrl: requestUrl,
    requestOptions: requestOptions
  };
};

var fetchRecentlyViewedProducts = function fetchRecentlyViewedProducts(config) {
  var _getRequestConfigByUs = getRequestConfigByUserType(config),
      requestUrl = _getRequestConfigByUs.requestUrl,
      requestOptions = _getRequestConfigByUs.requestOptions;

  return _axios.default.get(requestUrl, requestOptions).then(function (response) {
    return response.data;
  }).catch(function (e) {
    if (e.response && e.response.status !== 404) {
      triggerAnalyticsEvents({
        event: {
          eventDetails: {
            overlayName: 'Recently Viewed - Error',
            errorType: 'requestFailed'
          },
          eventInfo: {
            eventName: 'recentlyViewedFailed'
          }
        }
      });
    }

    return null;
  });
};

exports.fetchRecentlyViewedProducts = fetchRecentlyViewedProducts;

var deleteRecentlyViewedProducts = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(config) {
    var _getRequestConfigByUs2, requestUrl, requestOptions;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getRequestConfigByUs2 = getRequestConfigByUserType(config), requestUrl = _getRequestConfigByUs2.requestUrl, requestOptions = _getRequestConfigByUs2.requestOptions;
            return _context.abrupt("return", _axios.default.delete(requestUrl, requestOptions).then(function (response) {
              return true;
            }).catch(function (e) {
              return null;
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function deleteRecentlyViewedProducts(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.deleteRecentlyViewedProducts = deleteRecentlyViewedProducts;